var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function ArrowDiagonalIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L16.5858 6H13C12.4477 6 12 5.55228 12 5C12 4.44772 12.4477 4 13 4H19C19.5523 4 20 4.44772 20 5V11C20 11.5523 19.5523 12 19 12C18.4477 12 18 11.5523 18 11V7.41421L5.70711 19.7071Z", fill: "" })));
}
export var ArrowDiagonalIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: ArrowDiagonalIconInner }, props))); };
//# sourceMappingURL=ArrowDiagonalIcon.js.map